import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class ProcessMappingStepOutput extends BasicEntity {
description: TranslatedEmb;
entryId: number | null;
field: string;
fieldFormat: string;
fieldType: string;
label: TranslatedEmb;
orderNumber: number | null;
parentField: string;
processCode: string;
processMappingStepcode: string;
processValue: string;
visionCode: string;
}

